import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { senContactSubmissionDetails } from "../../redux/thunks/services";

const ContactForm = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.servicesReducer);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    service: "",
    message: "",
    hearAboutUs: "",
    contactMethod: "",
    privacyConsent: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.privacyConsent) {
      alert("You must consent to the privacy policy");
      return;
    }
    const addData = {
      name: formData?.fullName,
      phone: formData?.phone,
      email: formData?.email,
      subject: formData?.subject,
      service_of_intrest: parseInt(formData?.service),
      message: formData?.message,
      hear_about_us: formData?.hearAboutUs,
      pref_conatct_method: parseInt(formData?.contactMethod),
      consent_to_privacy_policy: formData?.privacyConsent,
    };
    // console.log(addData);

    setIsSubmitting(true);
    try {
      await dispatch(senContactSubmissionDetails(addData)).unwrap();

      setSubmitted(true);
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        subject: "",
        service: "",
        message: "",
        hearAboutUs: "",
        contactMethod: "",
        privacyConsent: false,
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <p className="text-green-600 text-lg font-semibold">
        Thanks for contacting us!
      </p>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 font-basefont"
    >
      <div>
        <label
          htmlFor="fullName"
          className="block text-sm font-bold mb-2 text-gray-700"
        >
          Full Name*
        </label>
        <input
          type="text"
          id="fullName"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
          required
          className="shadow border rounded w-full py-2 px-3"
        />
      </div>

      <div>
        <label
          htmlFor="email"
          className="block text-sm font-bold mb-2 text-gray-700"
        >
          Email Address*
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="shadow border rounded w-full py-2 px-3"
        />
      </div>

      <div>
        <label
          htmlFor="phone"
          className="block text-sm font-bold mb-2 text-gray-700"
        >
          Phone Number*
        </label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          className="shadow border rounded w-full py-2 px-3"
        />
      </div>

      <div>
        <label
          htmlFor="subject"
          className="block text-sm font-bold mb-2 text-gray-700"
        >
          Subject*
        </label>
        <input
          type="text"
          id="subject"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          required
          className="shadow border rounded w-full py-2 px-3"
        />
      </div>

      <div>
        <label
          htmlFor="service"
          className="block text-sm font-bold mb-2 text-gray-700"
        >
          Service of Interest*
        </label>
        <select
          id="service"
          name="service"
          value={formData.service}
          onChange={handleChange}
          required
          className="shadow border rounded w-full py-2 px-3"
        >
          <option value="">Select a service</option>
          <option value={1}>Import/Export Services</option>
          <option value={2}>Migration Services</option>
          <option value={3}>Residency by Investment</option>
          <option value={4}>Business Buy/Sell</option>
          <option value={5}>Real Estate Assistance</option>
          <option value={6}>Consulting Services</option>
          <option value={7}>Work Abroad</option>
          <option value={8}>Property Management</option>
          <option value={9}>Relocation Support</option>
        </select>
      </div>

      <div className="md:col-span-2">
        <label
          htmlFor="message"
          className="block text-sm font-bold mb-2 text-gray-700"
        >
          Message*
        </label>
        <textarea
          id="message"
          name="message"
          rows="4"
          value={formData.message}
          onChange={handleChange}
          required
          className="shadow border rounded w-full py-2 px-3"
        ></textarea>
      </div>

      <div>
        <label
          htmlFor="hearAboutUs"
          className="block text-sm font-bold mb-2 text-gray-700"
        >
          How did you hear about us?
        </label>
        <input
          type="text"
          id="hearAboutUs"
          name="hearAboutUs"
          value={formData.hearAboutUs}
          onChange={handleChange}
          className="shadow border rounded w-full py-2 px-3"
        />
      </div>

      <div>
        <label
          htmlFor="contactMethod"
          className="block text-sm font-bold mb-2 text-gray-700"
        >
          Preferred Contact Method*
        </label>
        <select
          id="contactMethod"
          name="contactMethod"
          value={formData.contactMethod}
          onChange={handleChange}
          required
          className="shadow border rounded w-full py-2 px-3"
        >
          <option value="">Select a method</option>
          <option value={1}>Email</option>
          <option value={2}>Phone</option>
          <option value={3}>Whatsapp</option>
        </select>
      </div>

      <div className="md:col-span-2 flex items-center">
        <input
          type="checkbox"
          id="privacyConsent"
          name="privacyConsent"
          checked={formData.privacyConsent}
          onChange={handleChange}
          className="form-checkbox h-5 w-5 text-basecolor"
          required
        />
        <label htmlFor="privacyConsent" className="ml-2 text-gray-700 text-sm">
          I consent to the privacy policy*
        </label>
      </div>

      <div className="md:col-span-2 text-center">
        <button
          type="submit"
          className="bg-bgcolor text-white font-semibold py-3 px-6 rounded-md hover:bg-basecolor focus:outline-none focus:shadow-outline"
          disabled={isLoading || isSubmitting}
        >
          {isLoading || isSubmitting ? (
            <>
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                />
              </svg>
              <span>Submitting...</span>
            </>
          ) : (
            "Submit Inquiry"
          )}
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
